// extracted by mini-css-extract-plugin
export default {"project_list":"ProjectList_project_list__kslkB","project_link":"ProjectList_project_link__UxT8d","list_item":"ProjectList_list_item__rVZhY"};